/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Hero_TemplateInputs */

const en_road_dude_hero_template = /** @type {(inputs: Road_Dude_Hero_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a prompt`)
};

const zh_road_dude_hero_template = /** @type {(inputs: Road_Dude_Hero_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选一条提示词`)
};

/**
* | output |
* | --- |
* | "Pick a prompt" |
*
* @param {Road_Dude_Hero_TemplateInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_hero_template = /** @type {((inputs?: Road_Dude_Hero_TemplateInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Hero_TemplateInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_hero_template(inputs)
	return zh_road_dude_hero_template(inputs)
});
export { road_dude_hero_template as "road_dude.hero.template" }